var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Server Error")]),_c('p',[_vm._v("An unexpected error has occurred")])])}
var staticRenderFns = []

export { render, staticRenderFns }